import React, { Component } from 'react';
import NewCrane from './new.js';
import CranesList from './list';
import DetailCrane from './detail.js'
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import ClipLoader from "react-spinners/ClipLoader";

class Cranes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      detail: false,
      loading:false,
      item:null,
    }
  }

  openDialog = () => {
    this.setState({open:true});
  }

  closeDialog = () => {
    this.setState({open:false, loading:true});
    setTimeout(() => {
          this.setState({loading:false});
    }, 3000)   
  }

  openDetail = (item) => {
    this.setState({detail:true, item:item});
  }

  closeDetail = () => {
    this.setState({detail:false, item:null});
  }

  updateCrane = (item) => {
    this.setState({item:item, open:true})
  }

  renderItem() { 
        return (
          <div>
            <CranesList 
              openDialog={()=> this.openDialog()} 
              openDetail={(item) => this.openDetail(item)} 
              closeDetail={()=>this.closeDetail()}
              updateCrane={(item)=>this.updateCrane(item)}
              />
              <Dialog open={this.state.open} onClose={()=>{console.log('closed')}} className="relative z-10">
                  <div className="fixed inset-0" />
                  <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                      <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                        <DialogPanel
                          transition
                          className="pointer-events-auto w-screen max-w-2xl transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
                        >
                          <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                            <div className="px-4 sm:px-6">
                              <div className="flex items-start justify-between">
                                <DialogTitle className="text-base font-semibold text-gray-900">
                                  {this.state.title}
                                </DialogTitle>
                                <div className="ml-3 flex h-7 items-center">
                                  <button
                                    type="button"
                                    onClick={() => this.setState({open:false, type:null})}
                                    className="relative rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
                                  >
                                    <span className="absolute -inset-2.5" />
                                    <span className="sr-only">Close panel</span>
                                    <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                <NewCrane closeDialog={()=>{this.closeDialog()}} item={this.state.item}/>
                            </div>
                          </div>
                        </DialogPanel>
                      </div>
                    </div>
                  </div>
              </Dialog>
              <DetailCrane openDetail={this.state.detail} closeDetail={()=>{this.closeDetail()}} item={this.state.item}/>
          </div>
        )
    }

  render(){
    return(
          <div>
            {
                this.state.loading ? 
                    <center>
                        <ClipLoader
                          color={'gray'}
                          loading={true}
                          size={50}
                          aria-label="Loading Spinner"
                          data-testid="loader"/>
                    </center>
                  :
                  this.renderItem()
            }
          </div>
      )
  }
}

export default Cranes;